import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SnapshotAlarmLogReturn } from 'types';

export const getAlarmLog = async (
  fromDate: string,
  toDate: string,
  analyzerId?: number | null | undefined,
  snapshotId?: number | null | undefined
): Promise<SnapshotAlarmLogReturn[] | undefined> => {
  const url = `/api/snapshot-alarm-log`;
  const query = {
    params: {
      fromDate: fromDate + ' 00:00:00.000',
      toDate: toDate + ' 23:59:59.999',
      analyzer:
        analyzerId && Number(analyzerId) !== -1 ? analyzerId : undefined,
      snapshot:
        snapshotId && Number(snapshotId) !== -1 ? snapshotId : undefined,
    },
  };
  const { data } = await axios.get(url, query);
  return data as SnapshotAlarmLogReturn[];
};

type QueryFnType = typeof getAlarmLog;

type UseAlarmLogOptions = {
  fromDate: string;
  toDate: string;
  analyzerId?: number | null | undefined;
  snapshotId?: number | null | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useAlarmLog = ({
  fromDate,
  toDate,
  analyzerId,
  snapshotId,
  config,
}: UseAlarmLogOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['alarmLog', fromDate, toDate, analyzerId, snapshotId],
    queryFn: () => getAlarmLog(fromDate, toDate, analyzerId, snapshotId),
  });
};
